import { Input, Select } from "components/form";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const OptionRowSkipSurvey = ({
  ind,
  optionData,
  skipDropdownList,
  questionDropdownOnChangeHandler,
}) => {
  //************************** Handle All State *********************//

  const [skipQuestionValue, setSkipQuestionValue] = useState();
  const { t } = useTranslation();

  //---------------   Handle Functions -------------//

  //   useEffect for set selected option
  useEffect(() => {
    if (optionData?.questionNumber) {
      setSkipQuestionValue(optionData?.questionNumber);
    }

    if (optionData?.isSurveyEnd) {
      setSkipQuestionValue("isSurveyEnd");
    }

    if (optionData?.isBlockEnd) {
      setSkipQuestionValue("isBlockEnd");
    }

    // eslint-disable-next-line
  }, [optionData?.questionNumber]);

  //************************** Handle HTML CODE *********************//
  return (
    <div key={`${ind}`} className="form_field_wrap">
      <div className="form_field">
        <Input
          type="text"
          isDisabled={true}
          className={"disable"}
          label={`${t(`CUSTOMIZATION_QUESTION.Option`)} ${ind + 1}`}
          value={optionData?.optionValue}
        />
      </div>
      <div className="form_field">
        <Select
          label={t(`CUSTOMIZATION_QUESTION.goto`)}
          value={skipQuestionValue}
          onChange={(e) =>
            questionDropdownOnChangeHandler(
              optionData,
              ind,
              e,
              setSkipQuestionValue
            )
          }
        >
          <option value={undefined}>
            {t(`CUSTOMIZATION_QUESTION.selectQuestion`)}
          </option>
          {skipDropdownList?.length > 0 &&
            skipDropdownList
              ?.filter((el) => el?.question?.length > 0)
              ?.map((el, ind) => (
                <option value={el?.value} key={`dropDownQues${ind + 2}`}>
                  {`Q${el?.questionNumber}. ${el?.question}`}
                </option>
              ))}
        </Select>
      </div>
    </div>
  );
};

export default OptionRowSkipSurvey;
